import { useEffect, useRef } from 'react'
import { ReactComponent as Right } from '../assets/icons/board-right.svg'
import { ReactComponent as Left } from '../assets/icons/board-left.svg'
import Slide from './Slide'

export default function BoardIndividualSideBar({
  studentBoardList,
  currentStudentNum,
  setCurrentStudentNum,
  isSideBarFold,
  setIsSideBarFold,
  setSideBarWidth,
  sideBarWidth,
  // socketEventResponse,
}) {
  //   console.log(location.state)
  // const [isSideBarFold, setIsSideBarFold] = useState(false)
  //   const [selectedSlide, setSelectedSlide] = useState([])
  // const [sideBarWidth, setSideBarWidth] = useState(0)
  const sideBarRef = useRef()

  useEffect(() => {
    const handleResize = () => {
      const { width } = sideBarRef.current?.getBoundingClientRect() ?? {
        width: 0,
      }
      // const width = sideBarRef.current?.offsetWidth
      setSideBarWidth(width)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
    // eslint-disable-next-line
  }, [isSideBarFold])

  useEffect(() => {
    function handleClickOutside(e) {
      // console.log(e.target.id)
      if (e.target.id === 'button') {
        setIsSideBarFold(true)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div
      // ref={sideBarRef}
      className='flex h-full min-w-min items-center transition-all duration-150'
    >
      <div
        onClick={() => setIsSideBarFold((prev) => !prev)}
        className='tab:h-60 tab:w-28 tab:rounded-l-8 board:h-[88px] board:w-40 board:rounded-l-8 absolute right-0 flex h-50 w-[22px] items-center justify-center rounded-l-4 bg-background-alternative stroke-border-active shadow-emphasize 3xl:h-120 3xl:w-[52px] 3xl:rounded-l-10'
        style={{ right: isSideBarFold ? '0px' : `${sideBarWidth}px` }}
      >
        {isSideBarFold ? (
          <Left className='tab:w-28 tab:h-28 h-32 w-32 3xl:h-[42px] 3xl:w-[42px]' />
        ) : (
          <Right className='tab:w-28 tab:h-28 h-32 w-32 3xl:h-[42px] 3xl:w-[42px]' />
        )}
      </div>
      <div
        ref={sideBarRef}
        className={`${isSideBarFold ? 'w-0 translate-x-full' : 'min-w-min translate-x-0'} fixed right-0 flex h-full flex-col border-l-2 border-border-default transition-all duration-150`}
      >
        <div
          className={`scroll-bar-xs board:scroll-bar tab:pl-12 tab:pt-16 flex w-full grow flex-col items-start overflow-y-scroll bg-fill-normal pl-6 pt-8 3xl:pl-16 3xl:pt-20`}
        >
          <div className='w-full'>
            {studentBoardList?.map((item, index) => (
              <div key={index} className='board:pb-12 tab:pb-8 pb-6'>
                <div
                  onClick={() => setCurrentStudentNum(item.studentNum)}
                  className='board:h-[132px] board:w-[232px] tab:h-[128px] tab:w-[224px] h-[90px] w-[158px] rounded-10 3xl:h-[178px] 3xl:w-[314px]'
                >
                  <Slide
                    url={item.studentBoard.backgroundImageUrl}
                    id={item.student.id}
                    studentData={item.student}
                    pageNum={item.studentNum}
                    //   selectedMode={isSelectedMode}
                    currentPage={currentStudentNum}
                    //   selectedSlide={null}
                    //   dragMode={isDragMode}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
